import api from './HttpService';
import { AUTH, USER } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&per_page=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search=${keyword}`;
  }

  try {
    const res = await api.get(USER.LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(USER.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${USER.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${USER.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${USER.DELETE}/${code}`);
  return res;
}

async function resendActivation(code) {
  const res = await api.get(`${AUTH.RESEND_ACTIVATION}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${USER.ACTIVE}`);
  return res;
}

const UserService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  resendActivation
};

export default UserService;
